import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { UserInfo, ComplexUserInfo, Response } from '../models';

export interface AddAvailableCollaborators {
  type: string;
  id_entity: string;
  is_new?: string;
}

@Injectable({ providedIn: 'root' })
export class CollaboratorsService {

  constructor(
    private http: HttpClient) { }



  removeCollabFromWorkspaceOrProject(idEntity: string, type: string, idUser: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/Workspaces-DeleteUserFromWorkspace`,
      {
        id_entity: idEntity,
        type,
        id_user: idUser
      }
    ).toPromise();
  }
  getCollaboratorsFilter(filter: any, page = 1, pageSize = 20): Promise<UserInfo[]> {
    //return this.http.post<UserInfo[]>(`${environment.apiUrl}/GetCollaboratorsFilter`, { ...filter, page, pageSize }).toPromise();
    return this.http.post<any>(`${environment.apiUrl}/GetCollaboratorsFilter`, { ...filter, page, pageSize }).toPromise();
  }

  getCollaboratorsByEntity(idEntity: string, type: string, page = 1, pageSize = 20): Promise<ComplexUserInfo> {
    let params = new HttpParams()
      .set('id-entity', idEntity)
      .set('type', type)
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    return this.http.get<ComplexUserInfo>(`${environment.apiUrl}/GetCollaboratorsByEntity`, { params }).toPromise();
  }

  getCollaboratorsGeneral(columnName?: string, orderBy?: string, page = 1, pageSize = 20): Promise<{ collaborator: UserInfo[] }> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    if (columnName && orderBy) {
      params = params.set('key', columnName).set('orderby', orderBy);
    }
    return this.http.get<{ collaborator: UserInfo[] }>(`${environment.apiUrl}/GetCollaboratorsGeneral`, { params }).toPromise();
  }

  getCollaboratorsGeneral_New(mail: string, page = 1, pageSize = 20): Promise<{ collaborator: UserInfo[] }> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    if (mail && mail !== '') {
      params = params.set('mail', mail);
    }
    return this.http.get<{ collaborator: UserInfo[] }>(`${environment.apiUrl}/GetCollaboratorsGeneral_New`, { params }).toPromise();
  }

  async getAvailableCollaborators(object: AddAvailableCollaborators): Promise<ComplexUserInfo> {
    let params = new HttpParams()
      .set('type', object.type)
      .set('id-entity', object.id_entity);
    if (object.is_new !== undefined) {
      params = params.set('is_new', object.is_new);
    }
    return this.http.get<ComplexUserInfo>(`${environment.apiUrl}/GetAvailableCollaborators`, { params }).toPromise();
  }

  changeJobTitle(idUserToChange: string, new_job_specification: any, new_role : string, special_property : any): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/ChangeJobTitle`,
      {
        id_user_to_change: idUserToChange,
          new_job_title_id: "",
          new_job_specification: new_job_specification,
        new_role: new_role,
        special_property : special_property
      }
    ).toPromise();
  }

  changeUserRole(idUserToChange: string, newRole: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/ChangeUserRole`,
      {
        id_user_to_change: idUserToChange,
        new_role: newRole
      }
    ).toPromise();
  }


  deleteUser(idUserToDelete: string): Promise<Response> {
    return this.http.get<Response>(`${environment.apiUrl}/DeleteUser`,
      {
          params:
        {
          idUserToDelete
        }
      }
    ).toPromise();
  }
}
